<div class="upsc-custom-adjuster-dashboard-payee">
  <div class="main">
    <form [formGroup]="payeeForm">
      <div class="content-container">
        <div class="heading-section">
          <h2 class="main-heading">Enter a policy number</h2>
          <p class="subtitle">Please type without version number</p>
        </div>
        
        <div class="input-section">
          <div class="input-container">
            <input type="text" 
                   class="policy-input-field" 
                   formControlName='policy' 
                   maxLength='25' 
                   placeholder="Policy Number *">
            <div *ngIf="policy.errors?.required && policy.touched" class="field-error-message">
              {{'userProfile.payee.errors.required' | translate}}
            </div>
            <div *ngIf="policy.errors?.minlength && policy.touched" class="field-error-message">
              {{'userProfile.payee.errors.invalid' | translate}}
            </div>
          </div>
          
          <div class="buttons-container">
            <button class="manage-payee-btn" role="button" type="button" [disabled]="!canSavePayee" (click)="openDPAT()">
              <span>{{'userProfile.payee.buttons.managePayee' | translate}}</span>
              <mat-icon class="chevron-icon">chevron_right</mat-icon>
            </button>
            <!-- <button class="smart-upload-btn" role="button" type="button" [disabled]="!canSavePayee" (click)="openSmartUpload()">
              <span>{{'userProfile.payee.buttons.smartUpload' | translate}}</span>
              <mat-icon class="chevron-icon">chevron_right</mat-icon>
            </button> -->
          </div>
        </div>

        <div *ngIf="hasPayeeError || hasBankingError" class="error-message">
          {{'notifications.payee.danger' | translate}}
        </div>
        <div *ngIf="systemError" class="error-message">
          {{ 'common.systemError' | translate }}
        </div>
      </div>
    </form>
  </div>
</div>